import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import * as CommonEnums from 'projects/Autofacets-Core/src/app/utils/enums';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { Subscription } from 'rxjs';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import * as Enums from '../../../../../../Autofacets-Core/src/app/utils/enums';
import { AppointmentDetail } from '../../../business-entities/appointmentDetail-model';
import { AppointmentList, AppointmentRequestModel, RentalCar } from '../../../business-entities/appointmentList-model';
import { AppointmentStatusList } from '../../../business-entities/appointmentStatus-model';
import { BrandViewModel } from '../../../business-entities/brand-view-model';
import { CustomerDetailsViewModel, CustomerVehicleModel, CustomerViewModel, DFCustomerDetailsViewModel, PackageDetails, VehicleDetail, VehicleViewModel } from '../../../business-entities/customer-vehicle-model';
import { AdditionalService, AppointmentServiceViewModel, DealerDetails, ServiceSelection } from '../../../business-entities/dealer-details.model';
import { PagerData } from '../../../business-entities/PagerData';
import { SelectListItemViewModel } from '../../../business-entities/select-list-item-view-model';
import { Features } from '../../../business-entities/user-role-view-model';
import { AddCustomerVehicleService } from '../../../business-services/add-vehicle-customer.service';
import { AppointmentService } from '../../../business-services/appointment.service';
import { CustomerService } from '../../../business-services/customer.service';
import { EditAppointmentService } from '../../../business-services/edit-appointment.service';
import { SettingService } from '../../../business-services/setting.service';
import { VehicleBusinessService } from '../../../business-services/vehicle-service';
import { MultiCustomerListComponent } from '../../customer/view-customer/customer-details/multi-customer-list/multi-customer-list.component';
import { ViewCustomerComponent } from '../../customer/view-customer/view-customer.component';
import { AddVehicleComponent } from '../../vehicle/add-vehicle/add-vehicle.component';
import { EditVehicleComponent } from '../../vehicle/edit-vehicle/edit-vehicle.component';
import { BrandService } from '../../../business-services/brand.service';
import { NgInfoModalContent } from 'projects/Autofacets-Core/src/app/shared/info-modal.component';
import { MultiStackPopupService } from '../../../services/multi-stack-popup.service';
import { UserRoleMenu } from '../../../business-entities/user-role-menu.model';
@Component({
  selector: 'app-add-appointments',
  templateUrl: './add-appointments.component.html',
  styleUrls: ['./add-appointments.component.css']
})
export class AddAppointmentsComponent implements OnInit {
  //#region Declaration

  private toasterShown = false;
  openPanels: Array<string> = ['first', 'second', 'third', 'forth','fifth'];
  timeSlotSection: boolean;
  searchLicensePlate: boolean = false;
  searchMobileNumber: boolean = false;
  IsCustomerAddFromVehicle: boolean = false;
  activeAppointmentList: AppointmentList[];
  serviceId: number;
  isNeedRentalCar: boolean;
  showAddAppointment: boolean = true;
  licensePlatNo: string = '';
  customerVehicle: CustomerVehicleModel;
  vehicleDetails: VehicleDetail[] = []
  customerDetails: CustomerDetailsViewModel[] = []
  existingDFCustomerDetails: DFCustomerDetailsViewModel[] = []
  crmVehicleDetails: any[] = [];
  crmCustomerDetails: any[] = [];
  radioSelected: number;
  vehicleSelected: number;
  dealerDeatils: DealerDetails[] = [];
  dealerBrandDeatils: DealerDetails[] = [];
  dealerDeatilList: DealerDetails[] = [];
  serviceDetails: ServiceSelection[] = [];
  selectedDealerName: string;
  customerList: CustomerViewModel[];
  package: PackageDetails[];
  vehicleList: VehicleViewModel[];
  radioSel: CustomerViewModel;
  addAppointment: boolean;
  vehicleSel: any;
  createForm: FormGroup;
  rentalCarAvailabilities: RentalCar[] = [];
  selectedRentalCarIndex: number
  dealerNextAvailDate: string;
  selectedDate: string;
  selectedDateTime: Date;
  recommendService: boolean;
  disableDatesOfCalender: string[];
  selectedDealer: DealerDetails;
  selectedServices: SelectListItemViewModel[];
  appointmentList: AppointmentList[];
  selectedService: DealerDetails;
  loginDealerIndex: number = -1;
  selectedServiceId: number = -1;
  isDealerLoggedIn: boolean;
  rentalCarValidationMessage = false;
  isView: boolean = false;
  availCheckInFacility: boolean;
  offertype: boolean;
  deliverOutsideBusinessHours = false;
  pickupOutsideBusinessHours = false;
  pickupTimeSlot: string;
  mobileNumber: string;
  mobileCode: any;
  customerPickupDropOffServiceSelection: boolean = false;
  pickUpHours: number = 0;
  pickUpMinutes: number = 0;
  PickupDatetime: Date;
  isDisplayVehicleForCustomer: boolean = false;
  addCustomerOrVehicle: boolean = false
  contactDetails: AppointmentDetail;
  appointmentRequestModel: AppointmentRequestModel =
    {
      appointmentStatusId: null,
      workOrderStatusId: null,
      bookingDate: null,
      createdDate: null,
      dealerId: null,
      serviceAdvisorId:null,
      isAuthorizedByServiceAdvisor:false,
      mechanicId: null,
      brandCode: null,
      startRecordNumber: 0,
      pageSize: 0,
      sortColumn: '',
      sortDirection: ''
    };
  RegAdvanceSearchRequestModel: any = {
    licensePlate: '',
    VINNumber: '',
    engineNumber: ''
  };
  RegAdvanceSearch: boolean = false;
  MobileAdvanceSearchRequestModel: any = {
    mobileNo: '',
    customerNo: '',
    firstName: ''
  };
  MobileAdvanceSearch: boolean = false;
  vehicleDetail: VehicleDetail[] = [];
  brandList: BrandViewModel[];
  pickupTimeSlotFlag: boolean;
  additionServicesForm: FormGroup;
  todayDate: string;
  endDate: string;
  serviceList: AppointmentServiceViewModel[] = [];
  ServicesSelected: AppointmentServiceViewModel[] = [];
  serviceModel: AppointmentServiceViewModel = {
    Description: '',
    FromRecommended: false
  };
  addDetails: boolean = false;
  isDisabled: boolean = true;
  SelectedLicencePlate: any = null;
  SelectedVehicleId: any = null;
  SelectedCustomerId: any = null;
  SelectedCustomerGuid: any = null;
  SelectedCustomer: any = null;
  SelectedMakeCode: any = null;
  previousKilometerValue: any = null;
  dealerRecommendedService: AdditionalService[] = [];
  selectedPackage: string;
  appointmentSub: Subscription;
  isRentalService: boolean = true;
  mileage: number;
  customerName: string = "";
  isMileageError: boolean = false;
  selectDate: boolean = false;
  features: Features[] = [];
  businesshours: string;
  licensePlateClass: string;
  dropdownSettings = {};
  ServiceId = [];
  servicesList: Array<SelectListItemViewModel>;
  serachByLicensePlate: boolean = true;
  searchMobileNo: any;
  pagerData: PagerData = {
    page: 1,
    pagerSize: Constant.GridPagerSize
  }
  display = 'block';
  ownerTypeId: number = 1;
  AppointmentHour: number;
  AppointmentMinutes: number;
  AppointmentDatetime: Date;
  appointmentStatusList: AppointmentStatusList[] = []
  isOrder: boolean = true;
  isOffer: boolean = false;
  isThirdPartyActive: boolean = false;
  TCLink: boolean = true;
  TCUrl: string = '';
  UserPrivacyAccept: boolean = false;
  UserConsent: boolean = false;
  popupCloseResult = false;
  isDealerNotify = true;
  isCustomerNotify = true;
  isAdminNotify = true;
  AssociateCustomer: boolean = false;
  AssociateVehicle: boolean = false;
  showCustomerVehicle: string = '';
  dmsFeature: Features;
  userRoleRightsDetails: UserRoleMenu;
  userRoleRightsDetailsVehicle: UserRoleMenu;
  VehicleNumberOnAddCustomer: string;
  _clientName: string;
  hideExtraInformation: boolean = false;
  hidePrivacyPolicy: boolean = false;
  hideMarketingConcent: boolean = false;
  dfCustomerForCRM: any;
  customerNo:any;
  isShowDMSStatus:boolean = false;
  @ViewChild('appointmentBookingCalendar') appointmentBookingCalendar: ElementRef;
  @ViewChild("pickUpminuteInput") pickUpminuteInput: ElementRef;
  @ViewChild("AppointmentminuteInput") AppointmentminuteInput: ElementRef;
  @ViewChild('customerRelationContent') customerRelationContent: TemplateRef<any>;

  //#endregion

  constructor(
    private readonly service: AppointmentService,
    private readonly translate: TranslateService,
    private readonly router: Router, 
    private readonly activeModal: NgbActiveModal,
    private readonly spinner: NgxSpinnerService,
    private readonly toaster: ToastrService,
    private readonly model: NgbModal,
    private readonly modalService: NgbModal,
    private readonly customerService: CustomerService,
    private readonly fcService: AddCustomerVehicleService,
    public settingService: SettingService,
    private readonly currentLanguageService: CurrentLanguage,
    private readonly cookieservice: CookieService,
    private readonly secureStorage: SecureStorage,
    private readonly userService: UserDataService,
    private readonly globalSetting: GlobalSetting,
    public vehicleService: VehicleBusinessService,
    private readonly editAppointmentService: EditAppointmentService,
    private readonly brandService: BrandService,
    private readonly multiStackPopupService: MultiStackPopupService
  ) { }

  ngOnInit(): void {
    this._clientName = localStorage.getItem("Theme");
    this.hideExtraInformation = this._clientName === 'mg';
    this.brandList = this.secureStorage.getKeyData("BrandList");
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === Enums.ModuleNames.Customer);
    this.userRoleRightsDetailsVehicle = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find((menu) => menu.moduleId === Enums.ModuleNames.Vehicle);

    this.GetAllAppointmentStatusList();
    if (this.secureStorage.getKeyData('feature')) {
      this.features = this.secureStorage.getKeyData('feature');
      if (this.features?.length > 0) {
        this.isRentalService = this.features.find(x => x.featureCode === CommonEnums.FeatureCode.RenatlCar)?.isActive;
        this.isThirdPartyActive = this.features.find(x => x.featureCode === CommonEnums.FeatureCode.ThirdPartyAPI)?.isActive;
        this.dmsFeature = this.features.find(x => x.featureCode === CommonEnums.FeatureCode.DMS);
        this.TCLink = this.features.find(x => x.featureCode === CommonEnums.FeatureCode.TCLINK)?.isActive
        if (this.TCLink) {
          this.TCUrl = this.features.find(x => x.featureCode === CommonEnums.FeatureCode.TCLINK)?.serviceUrl1;
        }
        this.hidePrivacyPolicy = this.features.find(x => x.featureCode === CommonEnums.FeatureCode.HidePrivacyPolicy)?.isActive;
        this.hideMarketingConcent = this.features.find(x => x.featureCode === CommonEnums.FeatureCode.HideMarketingConcent)?.isActive;
        this.isShowDMSStatus = this.features.find(x => x.featureCode === Enums.FeatureCode.ShowDMSStatus)?.isActive;
      }
    }
    this.service.mobilenumber = null;
    this.licensePlateClass = this.globalSetting.getGlobalLicencePlate();
    this.todayDate = Utility.GetFormattedDate(new Date())
    this.endDate = Utility.GetFormattedDate(this.getNextYearDate());
    this.addAppointment = false;
    this.isDealerLoggedIn = this.userService.currentUserValue.roleType === Enums.UserRoles.DealerAdmin;

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'value',
      textField: 'text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,
      searchPlaceholderText: 'Search here',
      maxHeight: 500
    };
    this.mobileNumber = this.editAppointmentService.appointmentDetails?.mobileNo;
    this.licensePlatNo = this.editAppointmentService.appointmentDetails?.licensePlate;
    if (this.licensePlatNo) {
      this.RegAdvanceSearch = false;
      this.SearchLicensePLate();
    }
    this.spinner.hide();
  }
  onRegAdvanceSearch() {
    this.RegAdvanceSearch = true;
    this.MobileAdvanceSearch = false;
  }
  onMobileAdvanceSearch() {
    this.MobileAdvanceSearch = true;
    this.RegAdvanceSearch = false;
  }
  AssociateDFCustomerWithVehicle() {
    this.vehicleService.vehicleId = this.vehicleList[0].vehicleId;
    this.vehicleService.vehicleGuid = this.vehicleList[0].id;
    this.vehicleService.licensePlate = this.vehicleList[0].licensePlateNo;
    this.vehicleService.make = this.vehicleList[0].companyMakeCode;
    this.vehicleService.model = this.vehicleList[0].companyModel;
    this.vehicleService.vinNo = this.vehicleList[0].chassisNo;
    this.vehicleService.existingCustomerNo = this.customerNo;
    this.vehicleService.selectedTab = 2;
    this.vehicleService.searchThroughLocalDF = true;
    const modalref = this.modalService.open(EditVehicleComponent, {
      size: 'lg',
      windowClass: 'EditPopup',
    });
    modalref.componentInstance.fromHistory = false;
    modalref.result.then(
      (_response) => {
        this.SearchLicensePLate();
        this.vehicleService.selectedTab = 1;
        this.vehicleService.existingCustomerNo = null;
        this.vehicleService.searchThroughLocalDF = false;
      },
      (_error) => {
        // This is intentional
        this.vehicleService.selectedTab = 1;
        this.vehicleService.existingCustomerNo = null;
        this.vehicleService.searchThroughLocalDF = false;
      }
    );
  }

  onCustomerSelection(customer:any){
    this.vehicleService.customerRelationType = null;
    this.customerNo = customer.customerNo;
    this.modalService.open(this.customerRelationContent, { size: 'md', ariaLabelledBy: 'modal-basic-title' }).result.then(async (result) => {
    }, (reason) => {
    });
  }

  changeRelationType(event:any,relation:any){
    if((event.target as HTMLInputElement).checked){
      this.vehicleService.customerRelationType = this.vehicleService.customerRelationType != null ? this.vehicleService.customerRelationType + ',' + relation : relation;
    }
    else{
      const ids = this.vehicleService.customerRelationType.split(',');
      const filteredIds = ids.filter(id => id !== relation.toString());
      this.vehicleService.customerRelationType = filteredIds.length > 0 ? filteredIds.join(',') : null;
    }
  }

  AssociateCustomerWithVehicle(vehicle: any) {
    this.vehicleService.vehicleId = vehicle.vehicleId;
    this.vehicleService.vehicleGuid = vehicle.id;
    this.vehicleService.licensePlate = vehicle.licensePlate;
    this.vehicleService.make = vehicle.makeCode;
    this.vehicleService.model = vehicle.brand;
    this.vehicleService.vinNo = vehicle.chassisNo;
    const modalref = this.modalService.open(EditVehicleComponent, {
      size: 'lg',
      windowClass: 'EditPopup',
    });
    modalref.componentInstance.fromHistory = false;
    modalref.result.then(
      (_response) => {
        this.SearchLicensePLate();
      },
      (_error) => {
        // This is intentional
      }
    );
  }
  AssociateVehicleWithCustomer(customer: any) {
    this.customerService.customerId = customer.customerId;
    this.customerService.customerNo = customer.customerNo;
    this.customerService.customerName = customer.customerName;
    this.customerService.customerDetail = customer;
    this.customerService.firstName = customer.firstName;
    this.customerService.lastName = customer.lastName;
    this.SelectedCustomerId = customer.customerId;
    this.SelectedCustomerGuid = customer.Id;
    this.SelectedCustomer = customer;
    this.customerService.contactId = customer.Id;
    const modalref = this.modalService.open(ViewCustomerComponent, { size: 'lg', windowClass: 'EditPopup' });
    modalref.componentInstance.isFromServiceAdvisor = false;
    modalref.componentInstance.fromVehicleScreen = false;
    modalref.result.then((_response) => {
      this.onCustomerChangeGetVehicle(customer.customerId, customer.isActive);
    }, _error => {
      // This is intentional
    });
  }
  getNextYearDate() {
    let todaysDate = new Date();
    return new Date(todaysDate.getFullYear() + 1, todaysDate.getMonth(), todaysDate.getDate());
  }
  changeAppointmentTypeToOrder(value: any) {
    this.isOrder = value;
    this.isOffer = !value;
  }
  changeAppointmentTypeToOffer(value: any) {
    this.isOrder = !value;
    this.isOffer = value;
  }
  getBusinessHour(date: Date) {
    let today = (new Date(date)).getDay();
    this.selectedDealer.openingHoursList.forEach(element => {
      if (element.dayNumbers.includes(today)) {
        this.businesshours = element.openingHours;
      }
    });
  }

  isDigit(event): void {
    const isDigit = Utility.isDigit(event);
    if (!isDigit) {
      event.preventDefault();
    }
  }


  ngOnDestroy(): void {
    if (this.appointmentSub) {
      this.appointmentSub.unsubscribe();
    }
  }


  OnClose() {
    this.activeModal.dismiss(true);
  }

  OnNext(content) {
    if (this._clientName === 'mg') {
      const selectedCustomer = this.crmCustomerDetails.find(x => x.contactId === this.SelectedCustomerGuid);
      if (selectedCustomer)
      {
        if (!(((selectedCustomer.gender === 2 && selectedCustomer.fullName) || 
        ((selectedCustomer.gender === 0 || selectedCustomer.gender === 1) && selectedCustomer.firstName && selectedCustomer.lastName)) && 
          selectedCustomer.email && selectedCustomer.phone)) {
          let customerEmptyNameError = this.translate.instant("lblCustomerInvalidData");
          this.toaster.warning(customerEmptyNameError);
          return;
        }
      }
      else {
        return;
      }
    }

    if (this.vehicleDetail?.length > 0) {
      let length = this.vehicleDetail.length - 1;
      this.SelectedVehicleId = this.SelectedVehicleId ?? this.vehicleDetail[length].vehicleId;
      this.SelectedLicencePlate = this.SelectedLicencePlate ?? this.vehicleDetail[length].licensePlate;
      this.SelectedMakeCode = this.SelectedMakeCode ?? this.vehicleDetail[length].makeCode;
    }
    if (this.vehicleList?.length > 0) {
      let length = this.vehicleList.length - 1;
      this.SelectedVehicleId = this.SelectedVehicleId ?? this.vehicleList[length].vehicleId;
      this.SelectedLicencePlate = this.SelectedLicencePlate ?? this.vehicleList[length].licensePlateNo;
      this.SelectedMakeCode = this.SelectedMakeCode ?? this.vehicleList[length].companyMakeCode;
    }
    if (this.mobileNumber == null || this.mobileNumber?.length === 0) {
      this.mobileNumber = this.searchMobileNo;
    }
    if (this.selectedDealer) {
      this.selectedDealerName = this.selectedDealer?.dealerName;
    }
    this.endDate = Utility.GetFormattedDate(this.getNextYearDate());
    if (!this.isDisabled) {
      this.OpenAppointmentPopUp(content);
    }
  }

  OnNextForSelectDate() {
    this.selectDate = true;
    this.addDetails = false;
  }

  Back() {
    this.SelectedVehicleId = null;
    this.SelectedLicencePlate = null;
    this.SelectedMakeCode = null;
    this.selectDate = false;
    this.selectedServices = null;

    this.dealerDeatilList = this.dealerDeatils;
    if (!this.serachByLicensePlate) { this.vehicleList = []; this.isDisabled = true; }
    else {
      this.mobileNumber = null;
    }
  }

  checkMileage() {
    if (this.mileage && (this.mileage < 1 || this.mileage.toString().length > 7)) {
      this.isMileageError = true;
    }
    else {
      let regexp = /^[0-9]{0,7}$/;
      let testMileage = regexp.test(this.mileage.toString());
      this.isMileageError = testMileage ? false : true;
    }
  }

  getCustomerDetailsUsingMobileQuickSearch() {
    this.ResetMobileAdvanceSearch();
    this.getCustomerDetailsUsingMobile();
  }

  async getCustomerDetailsUsingMobile() {
    this.customerService.IsCustomerAddFromVehicle = false;
    this.customerService.VehicleNumber = null;
    this.customerService.CustomerId = null;
    this.customerService.CustomerNumber = null;
    this.SelectedCustomerId = null;
    this.SelectedCustomerGuid = null;
    this.SelectedCustomer = null;
    this.customerName = "";
    this.RegAdvanceSearch = false;
    this.MobileAdvanceSearch = false;
    this.isDisabled = true;
    if (this.mobileNumber === undefined || this.mobileNumber === null) {
      let ErrorMsg = this.translate.instant("lblPleaseEnterTheValue");
      this.toaster.error(ErrorMsg);
    }
    if ((this.mobileNumber !== undefined && this.mobileNumber !== null) || this.MobileAdvanceSearchRequestModel.mobileNo != '' || this.MobileAdvanceSearchRequestModel.customerNo || this.MobileAdvanceSearchRequestModel.firstName) {
      this.spinner.show();
      this.mobileNumber = this.mobileNumber ?? '';
      this.MobileAdvanceSearchRequestModel.mobileNo = this.MobileAdvanceSearchRequestModel.mobileNo ?? '';
      this.MobileAdvanceSearchRequestModel.customerNo = this.MobileAdvanceSearchRequestModel.customerNo ?? '';
      this.MobileAdvanceSearchRequestModel.firstName = this.MobileAdvanceSearchRequestModel.firstName ?? '';

      this.serachByLicensePlate = false;
      this.addCustomerOrVehicle = false;

      this.isDisplayVehicleForCustomer = false;
      this.vehicleDetail = [];
      this.licensePlatNo = null;
      this.customerList = [];
      this.vehicleList = [];
      this.customerDetails = [];
      this.existingDFCustomerDetails = [];
      this.vehicleService.existingCustomerNo = null;
      this.service.mobilenumber = this.mobileNumber;
      this.processCustomerList();
    }
    else {
      this.vehicleDetail = [];
      this.licensePlatNo = null;
      this.customerList = [];
      this.vehicleList = [];
      this.vehicleDetails = [];
      this.customerDetails = [];
      this.existingDFCustomerDetails = [];
      this.vehicleService.existingCustomerNo = null;
      this.isDisabled = true;
    }
  }
  async processCustomerList() {
    await this.fcService.getCustomerListUsingMobile(this.mobileNumber, this.MobileAdvanceSearchRequestModel.mobileNo, this.MobileAdvanceSearchRequestModel.customerNo,
      this.MobileAdvanceSearchRequestModel.firstName)
      .then(async (result) => {
        const responseObject = result.responseObject.result;
        if (responseObject.errorCode != null) {
          this.spinner.hide();
          this.addCustomerOrVehicle = true;
          let msg = this.translate.instant("lblCustomerNotFoundAddWarning")
          this.toaster.error(msg);
          this.vehicleDetails = [];
          this.customerDetails = [];
          this.existingDFCustomerDetails = [];
          this.OnThirdPartyCustomerSearch()
        }

        else {

          if (responseObject && responseObject?.length > 0) {
            if (this._clientName === 'mg') {
              this.crmCustomerDetails = this.mapCrmCustomerDetail(responseObject);
            }
            this.customerDetails = this.mapCustomerDetail(responseObject);
          } else if (this._clientName === 'mg') {
            let lblCustomerDetailsAreNotFound = this.translate.instant("lblCustomerDetailsAreNotFound.");
            this.toaster.error(lblCustomerDetailsAreNotFound);
          }
          const searchRequest = {
            birthDate: '',
            customerName: this.MobileAdvanceSearch ? this.MobileAdvanceSearchRequestModel.firstName : this.customerName,
            postCode: null,
            mobile: this.MobileAdvanceSearch ? this.MobileAdvanceSearchRequestModel.mobileNo : this.mobileNumber
          }
          await this.SearchedCustomerDFSearch(searchRequest, true)
        }
      });
  }

  AddCustomerThroughVehicleSearch(event) {
    this.spinner.show();
    this.mobileNumber = event.mobileNo;
    this.MobileAdvanceSearchRequestModel.customerNo = "";
    this.MobileAdvanceSearchRequestModel.firstName = event.customerName;
    this.customerName = event.customerName;
    this.IsCustomerAddFromVehicle = true;
    this.DFCustomerSearch();
    this.currentLanguageService.vehicleAdd.subscribe((x) => {
      if (x == 1) {
        this.SearchLicensePLate();
        this.currentLanguageService.vehicleAdd.next(0);
      }
    })
    this.mobileNumber = "";
    this.customerName = "";
  }

  goToAdditionalServiceSection(): void {
    this.spinner.show();
    this.service.GetAdditionalServices(this.selectedDealer.dealerId)
      .then((result) => {
        if (result?.responseObject?.errorCount === 0
          && result?.responseCode === CommonEnums.ErrorCodes.SuccessCode) {
          const dealerRecommendedService = result.responseObject.result as AdditionalService[];
          if (this.selectedService) {
            this.removeSelectedServicesFromRecommendations(dealerRecommendedService);
          }
        } else if (result.responseObject && result.responseObject.errorCount > 0) {
          if (result.responseObject.result &&
            result.responseObject.result.errorCode === CommonEnums.ErrorCodes.DealerAdditionalServiceNotFound) {
            this.dealerRecommendedService = [];
          }
        }
        this.spinner.hide();
      });

  }

  removeSelectedServicesFromRecommendations(dealerRecommendedService: AdditionalService[]): void {
    const service = dealerRecommendedService.filter(x =>
      this.selectedService.service.findIndex(y => y.serviceId === x.serviceId) === -1
    );
    this.additionServicesForm = new FormGroup({});

    service.forEach(x => {
      let value = null;
      if (this.selectedService) {
        value = this.selectedService.service[x.serviceId.toString()];
      }
      this.additionServicesForm.addControl(x.serviceId.toString(), new FormControl(value, []));
    });
    this.dealerRecommendedService = service;
  }
  async getAllDealerDetails(_isTrue: boolean) {
    this.spinner.show();
    this.selectedDealer = null;
    this.loginDealerIndex = -1;
    this.serviceDetails = [];
    let LanguageCode = this.cookieservice.get('userSelectedLanguage');
    const viewModel = { CustomerLatitude: 0, CustomerLongitude: 0, VehicleId: this.SelectedVehicleId, VehicleBrand: this.SelectedMakeCode, Language: LanguageCode };
    await this.service.GetAllDealerDetails(viewModel)
      .then((result) => {
        if (result.responseObject && result.responseObject.errorCount === 0 &&
          result.responseCode === Constant.SuccessResponseCode) {
          this.dealerDeatils = result.responseObject.result as DealerDetails[];
          const sortedDealerDetails = this.dealerDeatils.slice().sort((x, y) => x.dealerName.localeCompare(y.dealerName))
          this.dealerDeatils = sortedDealerDetails;
          this.dealerDeatilList = this.dealerDeatils;
          this.dealerBrandDeatils = result.responseObject.result as DealerDetails[];

          let associatedDealerId = this.userService.currentUserValue.dealerId?.split(',');
          if (associatedDealerId != null && associatedDealerId.length === 1) {
            let dealerdetail = this.dealerDeatilList.find(x => x.dealerId === associatedDealerId[0]);
            this.onChangeDealer(dealerdetail.dealerId);
          }

          if (this.editAppointmentService.appointmentDetails?.dealerId) {
            this.selectedDealer = this.dealerDeatilList.find(x => x.dealerId === this.editAppointmentService.appointmentDetails?.dealerId);
            this.onChangeDealer(this.editAppointmentService.appointmentDetails?.dealerId);
          }
          this.isDealerBrandValid();
          if (this._clientName === 'mg') {
            if (!(this.SelectedLicencePlate && this.SelectedCustomerGuid && this.selectedDealer)) {
              this.isDisabled = true;
            }
          } else if (!this.SelectedCustomerId || !this.SelectedVehicleId || !this.selectedDealer) {
            this.isDisabled = true;
          }

        }
        this.spinner.hide();
      });
  }
  mapdealer(array: ServiceSelection[]) {
    let supperArray = [];
    if (array && array.length > 0) {
      array.forEach(element => {
        let single = Object();
        single.value = element.id
        single.text = element.name

        supperArray.push(single);
      });
    }
    return supperArray;
  }

  get cpf() {
    return this.createForm.controls;
  }

  OpenAddCustomerModel(): void {

    this.customerService.customerId = 0;
    this.customerService.customerNo = '';
    this.customerService.customerName = '';
    const modalref = this.model.open(ViewCustomerComponent, { size: 'lg', windowClass: 'EditPopup' });
    modalref.result.then((response) => {
      if (response.success) {
        this.licensePlatNo = response.licensePlate;
        this.mobileNumber = this.customerService.customerMobileNo;
        this.getCustomerDetailsUsingMobile();
        this.showAddAppointment = true;
        this.addCustomerOrVehicle = false;
      }
    },
      _error => {
        this.showAddAppointment = this.service.isShow;
        this.addCustomerOrVehicle = false;
      });
  }


  getDealerRentalCarDetails() {

    if (this.isNeedRentalCar && !this.timeSlotSection && this.selectedDealer !== undefined && this.selectedDealer.dealerId !== undefined) {
      this.spinner.show();
      this.service.GetDealerRentalCars(this.selectedDealer.dealerId).then((result) => {
        if (result.responseObject && result.responseObject.errorCount === 0 &&
          result.responseCode === CommonEnums.ErrorCodes.SuccessCode) {
          this.rentalCarAvailabilities = result.responseObject.result as RentalCar[];
          this.onChangeRentalCar();
        }
      })
      this.spinner.hide();
    }
    else {
      this.onChangeRentalCar();
    }
  }

  applyRentalCarChangesOnCalender(): void {
    if (this.isRentalCarSelected()) {
      this.makeAvailableDateGeenInCalender();
    } else {
      this.rentalCarValidationMessage = false;
      this.removeClassFromCalender('date-green-bg');
    }
  }
  onChangeRentalCar() {
    this.rentalCarValidationCheck();
    this.applyRentalCarChangesOnCalender();
  }
  isRentalCarSelected(): boolean {
    return !this.timeSlotSection && this.isNeedRentalCar && this.selectedRentalCarIndex > -1;
  }

  rentalCarValidationCheck(): void {
    if (this.isRentalCarSelected()) {
      this.rentalCarValidationMessage = this.getRentalCarAvailablilityStatus();
    } else {
      this.rentalCarValidationMessage = false;
    }
  }
  getRentalCarAvailablilityStatus(): boolean {
    return this.rentalCarAvailabilities[this.selectedRentalCarIndex]
      .notAvailableDates.map(date => Utility.GetFormattedDate(date)).findIndex(y => y === this.selectedDate) > -1;
  }
  makeAvailableDateGeenInCalender() {
    const notAvailableDate = this.rentalCarAvailabilities[this.selectedRentalCarIndex]?.notAvailableDates;
    if (notAvailableDate) {
      const notAvailableDateStrings = notAvailableDate.map(x => Utility.GetFormattedDate(x));
      this.setClassOfCalenderExcept('date-green-bg', notAvailableDateStrings);
    }
  }
  setClassOfCalenderExcept(className: string, data: string[]): void {
    const calendar = this.appointmentBookingCalendar?.nativeElement?.querySelectorAll('.xdsoft_date:not(.xdsoft_disabled)');
    if (calendar) {
      // tslint:disable-next-line: no-shadowed-variable
      for (const element of calendar) {
        const mainDate = this.getDateStringFromCalenderElement(element);
        const index = data.findIndex(x => x === mainDate);
        if (index !== -1) {
          element.classList.remove(className);
        } else {
          element.classList.add(className);
        }
      }
    }
  }
  MoveToAppointmentDurationMinute(e) {
    this.MoveAppointmentToMinute(e, true);
  }
  MoveAppointmentToMinute(e, isToDuration = false) {
    //keyss to ignore
    const ignoreKeyCodes: Array<number> = [16, 9];

    //ignore keys check
    if (!ignoreKeyCodes.some(x => x == e.keyCode)) {
      //get the current element
      const target = e.srcElement;
      const maxLength = parseInt(target.attributes["maxlength"].value, 10);
      const myLength = target.value.length;
      //make a length check
      if (myLength >= maxLength) {
        //grab to element to focus on
        if (this.AppointmentHour >= 24) {
          this.AppointmentHour = 23;
        }
        let minInput;
        if (isToDuration) {
          minInput = this.AppointmentminuteInput.nativeElement;
        }
        if (minInput) {
          //focus the element
          minInput.focus();
        }
      }
    }
  }
  CheckAppointmentMinute(_e) {
    if (this.AppointmentMinutes >= 60) {
      this.AppointmentMinutes = 59;
    }
  }
  removeClassFromCalender(className: string): void {
    const calendar = this.appointmentBookingCalendar?.nativeElement?.querySelectorAll('.xdsoft_date');
    if (calendar) {
      // tslint:disable-next-line: no-shadowed-variable
      for (const element of calendar) {
        element.classList.remove(className);
      }
    }
  }

  MoveToDurationMinute(e) {
    this.MoveToMinute(e, true);
  }

  MoveToMinute(e, isToDuration = false) {
    //keyss to ignore
    const ignoreKeyCodes: Array<number> = [16, 9];

    //ignore keys check
    if (!ignoreKeyCodes.some(x => x == e.keyCode)) {
      //get the current element
      const target = e.srcElement;
      const maxLength = parseInt(target.attributes["maxlength"].value, 10);
      const myLength = target.value.length;
      //make a length check
      if (myLength >= maxLength) {
        //grab to element to focus on
        if (this.pickUpHours >= 24) {
          this.pickUpHours = 23;
        }
        let minInput;
        if (isToDuration) {
          minInput = this.pickUpminuteInput.nativeElement;
        }
        if (minInput) {
          //focus the element
          minInput.focus();
        }
      }
    }
  }

  CheckMinute(_e) {
    if (this.pickUpMinutes >= 60) {
      this.pickUpMinutes = 59;
    }
  }

  onChangeCustomerPickupDropupServiceCheckbox() {
    this.timeSlotSection = false;
    this.onChangeRentalCar();
    if (!this.isDealerLoggedIn) {
      this.selectedDealer = null;
      this.loginDealerIndex = -1;
    }
    if (this.serviceId) {
      this.onChangeService(this.serviceId);
    }
  }

  onChangeCustomerWaitingCheckbox(): void {
    if (this.selectedDealer?.dealerId) {
      this.checkPickupTimeSlot();
      this.isNeedRentalCar = false;
    }
  }

  checkPickupTimeSlot(): void {
    if (this.timeSlotSection && !this.pickupTimeSlot) {
      this.pickupTimeSlotFlag = true;
      if (this.pickupTimeSlotFlag) {
        this.spinner.show();
        let model = {
          selectedDate: Utility.getDateStringToDate(this.selectedDate).toDateString(),
          dealerId: this.selectedDealer.dealerId
        }
        this.service.GetCustomerWaitingLimit(model).then((res) => {
          if (res.responseObject > 0) {
            this.timeSlotSection = true
          }
          else {
            this.timeSlotSection = false;
            let msg = this.translate.instant("lblCustomerWaitingLimitExist")
            this.toaster.error(msg)
          }
        })
        this.spinner.hide();
      }
    }
    else {
      this.pickupTimeSlotFlag = false;
    }
  }
  onSearchLicensePLate() {
    this.RegAdvanceSearch = false;
    this.SearchLicensePLate();
  }
  ApplyRegAdvanceSearch() {
    if (this.RegAdvanceSearchRequestModel.licensePlate || this.RegAdvanceSearchRequestModel.VINNumber || this.RegAdvanceSearchRequestModel.engineNumber) {
      this.RegAdvanceSearch = true;
      this.SearchLicensePLate();
    }
    else {
      let ErrorMsg = this.translate.instant("lblPleaseEnterTheValue");
      this.toaster.error(ErrorMsg);
    }
  }
  ResetRegAdvanceSearch() {
    this.RegAdvanceSearchRequestModel = {
      licensePlate: '',
      VINNumber: '',
      engineNumber: ''
    }
  }
  CloseRegAdvanceSearch() {
    this.RegAdvanceSearch = false;
    this.ResetRegAdvanceSearch();
  }
  ApplyMobileAdvanceSearch() {
    if (this.MobileAdvanceSearchRequestModel.mobileNo != '' || this.MobileAdvanceSearchRequestModel.customerNo || this.MobileAdvanceSearchRequestModel.firstName) {
      this.vehicleList = [];
      this.customerDetails = [];
      this.MobileAdvanceSearch = false;
      this.mobileNumber = this.MobileAdvanceSearchRequestModel.mobileNo;
      this.getCustomerDetailsUsingMobile();
    }
    else {
      let ErrorMsg = this.translate.instant("lblPleaseEnterTheValue");
      this.toaster.error(ErrorMsg);
    }
  }
  ResetMobileAdvanceSearch() {
    this.MobileAdvanceSearchRequestModel = {
      mobileNo: '',
      customerNo: '',
      firstName: ''
    }
  }
  CloseMobileAdvanceSearch() {
    this.MobileAdvanceSearch = false;
    this.ResetMobileAdvanceSearch();
  }
  ShowThirdPartyAlert() {
    if (this.isThirdPartyActive) {
      let modelBodymsg = this.translate.instant('lblSureToSearchDF');
      let modelHeadermsg = this.translate.instant('lblDFSearch');
      const modalRef = this.modalService.open(NgbdModalContent);
      modalRef.componentInstance.modelHeader = modelHeadermsg;
      modalRef.componentInstance.modelBody = modelBodymsg;
      modalRef.result.then(
        () => {
          // This is intentional
        },
        reason => {
          if (reason) {
            if (this.isThirdPartyActive) {
              this.OnDFVehicleSearch()
            }
          }
        }
      );
    }
  }

  async OnDFVehicleSearch(){
      this.spinner.show();
      this.dfCustomerForCRM = null;
      await this.vehicleService.getVehicleFrmoDataFactoryByLicencePlateNo(this.licensePlatNo).then((response) => {
        if (response.responseCode === Constant.SuccessResponseCode) {
          if(response.responseObject != null && response.responseObject.length != 0){
            if(response.responseObject[0].vehicles == null){
              this.vehicleDetails = null;
              let errorMsg = this.translate.instant('lblVehicleDetailsNotFound');
              this.toaster.error(errorMsg);
              this.spinner.hide();
            }
            else if(response?.responseObject == null || response.responseObject[0].personDetail == null){
              this.vehicleDetails = null;
              let errorMsg = this.translate.instant('lblVehicleDetailsNotFound');
              this.toaster.error(errorMsg);
              this.spinner.hide();
            }
            else{
              let result = response.responseObject[0].vehicles[0];
              if (this._clientName === 'mg') {
                this.crmMapDFCustomer(response.responseObject[0]);
              }
              this.OnAddVehicle(result);
              this.spinner.hide();
            }
          }
          else{
            let errorMsg = this.translate.instant('lblVehicleDetailsNotFound');
            this.toaster.error(errorMsg);
            this.spinner.hide();
          }
        }
      },
      _error => {
        this.spinner.hide();
      });
  }

  crmMapDFCustomer(response) {
    this.dfCustomerForCRM = {
      customerId: 0,
      contactId: '',
      firstName: response.names[0].firstName,
      lastName: response.names[0].lastName,
      fullName: response.names[0].fullName,
      addressLine1: response.addresses[0].address,
      city: response.addresses[0].city,
      postCode: response.addresses[0].postalCode,
      email: response.phones[0].email,
      phone: response.phones[0].number,
      contactRemark: '',
      gender: this.getGenderIndex(response.personDetail.gender),
      state: response.addresses[0].municipalName,
      isActive: true,
      ownerTypeId: this.getOwnerTypeIndex(response.vehicles[0].ownerType),
    }
  }

  getGenderIndex(gender: string) {
    switch(gender.toLowerCase()) {
      case 'male':
        return 0;
      case 'female':
        return 1;
      case 'company':
        return 2;
    }
  }

  getOwnerTypeIndex(ownerType: string) {
    switch(ownerType.toLowerCase()) {
      case 'owner':
        return 1;
      case 'user':
        return 8;
    }
  }

  SearchLicensePLate() {
    let licensePlate = this.RegAdvanceSearch ? this.RegAdvanceSearchRequestModel.licensePlate : this.licensePlatNo;
    this.VehicleNumberOnAddCustomer = licensePlate;
    licensePlate = licensePlate?.trim();
    this.AssociateCustomer = false;
    this.isDisplayVehicleForCustomer = false;
    this.MobileAdvanceSearch = false;
    if (licensePlate?.length > 0 || this.RegAdvanceSearch) {
      this.serachByLicensePlate = true;
      let errorMessage = this.translate.instant("lblErrorMessage");
      let WarningMessage = this.translate.instant("lblErrorWarningForValue")
      this.spinner.show();
      this.isView = false;
      this.mobileNumber = null;
      this.service.mobilenumber = null;
      this.mobileCode = null;
      this.searchLicensePlate = false;
      this.vehicleDetail = [];
      this.customerList = [];
      this.vehicleList = [];
      this.getBrands();
      this.customerDetails = [];
      this.vehicleDetails = [];
      this.SelectedVehicleId = null;
      this.SelectedCustomerId = null;
      this.SelectedCustomerGuid = null;
      this.SelectedCustomer = null;
      this.GetAllAppointmentStatusList();
      this.service.SearchLicensePLate(licensePlate, this.RegAdvanceSearchRequestModel.VINNumber, this.RegAdvanceSearchRequestModel.engineNumber).then(async res => {
        this.spinner.hide();
        this.handleLiencePlateRes(res);
      }, error => {
        this.spinner.hide();
        const isBadRequest = error.status === Constant.BadRequest;
        const message = isBadRequest ? WarningMessage : errorMessage;

        this.toaster[isBadRequest ? 'warning' : 'error'](message);


      }).finally(() => {
        this.RegAdvanceSearch = false;
        this.MobileAdvanceSearch = false;
      });
    }
    else {
      let ErrorMsg = this.translate.instant("lblPleaseEnterTheValue");
      this.toaster.error(ErrorMsg);
      this.searchLicensePlate = true;
      this.vehicleDetail = [];
      this.customerList = [];
      this.vehicleList = [];
      this.vehicleDetails = [];
      this.customerDetails = [];
      this.existingDFCustomerDetails = [];
      this.isDisabled = true;
    }
  }

  handleLiencePlateRes(res) {
    if (res.responseCode === Constant.SuccessResponseCode && res.responseObject.customerList != null) {
      this.addAppointment = true;
      this.customerVehicle = res.responseObject;
      this.customerList = this.customerVehicle.customerList;
      let customerId = this.customerList?.filter(x => x.isActive === true)[0]?.customerId;
      let customerGuid = this.customerList?.filter(x => x.isActive === true)[0]?.contactId;
      this.vehicleList = this.customerVehicle.vehicleList;
      this.SelectedVehicleId = this.vehicleList[0]?.vehicleId;
      this.SelectedCustomerId = (customerId !== null || customerId !== undefined) ? customerId : this.customerList[0]?.customerId;
      this.SelectedCustomerGuid = (customerGuid !== null || customerGuid !== undefined) ? customerGuid : this.customerList[0]?.contactId;
      this.SelectedCustomer = this.customerList?.filter(x => x.isActive === true)[0];
      this.SelectedMakeCode = this.vehicleList[0]?.companyMakeCode;
      this.SelectedLicencePlate = this.vehicleList[0]?.licensePlateNo;
      this.previousKilometerValue = this.vehicleList[0]?.previousKilometer;
      if (this._clientName === 'mg') {
        this.crmCustomerDetails = this.mapCrmCustomerDetail(this.customerList, true);
        this.crmVehicleDetails = this.mapCrmVehicleDetails(this.vehicleList);
      }
      if (this.customerList && this.customerList.length > 0) {
        this.customerDetails = this.mapCustomerDetails(this.customerList);
        // this.customerDetails.forEach(element => {
        //   var customer = this.SearchedCustomerDFSearch(element.customerName,element.mobileNo)
        // });
      }
      if (this.vehicleList && this.vehicleList.length > 0) {
        this.vehicleDetails = this.mapVehicleDetails(this.vehicleList, false);
        this.SearchedVehicleDFSearch(this.vehicleDetails[0].licensePlate, false, true)
      }

      if (!(this.customerList && this.customerList.length > 0)) {
        this.isDisabled = true;
        this.AssociateCustomer = true;
      }
      this.customerName = this.customerDetails.find(x => x.isActive === true)?.customerName;
      this.searchMobileNo = this.customerDetails.find(x => x.isActive === true)?.mobileNo;
      this.mobileCode = this.customerDetails.find(x => x.isActive === true)?.mobileCode;
      this.getAllDealerDetails(false);
      if ((this.SelectedCustomerId !== null && this.SelectedCustomerId !== undefined && this.SelectedCustomerId < 0) || (this.SelectedVehicleId !== null && this.SelectedVehicleId !== undefined && this.SelectedVehicleId < 0) && (this.selectedDealer?.dealerId !== null || this.selectedDealer?.dealerId !== undefined)) {
        let errorMsg = this.translate.instant("lblNoDealerAvailabilityForThisVehicleBrand");
        this.toaster.error(errorMsg);
        return;
      }
    }
    else if ((this._clientName === 'mg' && res.responseObject.result.errorCode === Enums.ErrorCodes.NoContent) || (parseInt(res.responseObject.result.errorCode) === Enums.ErrorCodes.DataNotFoundErrorCode)) {
      this.addAppointment = false;
      this.vehicleDetails = [];
      this.customerDetails = [];
      this.isDisabled = true;
      let msg = this.translate.instant("lblVehicleNotFound")
      this.toaster.error(msg);
      this.ShowThirdPartyAlert()
    }
    else if (this._clientName === 'mg' && res.responseObject.errorCount > 0) {
      this.addAppointment = false;
      this.vehicleDetails = [];
      this.customerDetails = [];
      this.isDisabled = true;
      let msg = this.translate.instant("lblApiServiceUnavailable");
      this.toaster.error(msg);
    }
  }
  private mapVehicleDetails(vehicle: any, isFromCustomerSelection) {
    let supperArray = [];
    if (isFromCustomerSelection) {
      if (vehicle && vehicle.length > 0) {
        vehicle.forEach(element => {
          let single = Object();
          single.vehicleId = element.vehicleId
          single.licensePlateNo = element.licensePlate
          single.companyMakeCode = element.companyMakeCode
          single.model = element.companyModel
          single.color = element.color
          single.year = element.year
          single.registrationDate = element.registrationDate
          single.fuel = element.fuelType
          single.brand = element.companyMakeCode;
          single.vehicleGroup = element.vehicleGroup
          single.chassisNo = element.chassisNo
          single.ownerType = element.ownerType
          single.ownerTypeId = element.ownerTypeId
          single.searchSource = element.sourceOfCreation ?? "Local"
          single.inspectionNextDate = element.inspectionNextDate;
          single.isExistingVehicle = element.isExistingVehicle;
          single.remark = element.remark;
          single.isImported = !this.empty(element.isImported) ? element.isImported : false;
          supperArray.push(single);
        })
      }
    } else if (vehicle && vehicle.length > 0) {
      vehicle.forEach(element => {
        let single = Object();
        single.vehicleId = element.vehicleId
        single.licensePlate = element.licensePlateNo
        single.makeCode = element.companyMakeCode
        single.model = element.companyModel
        single.color = element.color
        single.year = element.year
        single.registrationDate = element.registrationDate
        single.inspectionNextDate = element.inspectionNextDate
        single.fuel = element.fuelType
        single.brand = element.companyMakeCode;
        single.vehicleGroup = element.vehicleGroup
        single.chassisNo = element.chassisNo
        single.id = element.id
        single.searchSource = element.searchSource ?? 'Local'
        single.isExistingVehicle = element.isExistingVehicle
        single.remark = element.remark
        single.isImported = !this.empty(element.isImported) ? element.isImported : false;
        supperArray.push(single);
      })
    }
    return supperArray;
  }
  private mapCrmVehicleDetails(vehicle: any, isFromCustomerChange = false) {
    let supperArray = [];
    if (isFromCustomerChange) {
      if (vehicle && vehicle.length > 0) {
        vehicle.forEach(element => {
          let single = Object();
          single.id = element.vehicleId
          single.licensePlateNo = element.licensePlate
          single.companyModel = element.companyModel
          single.color = element.color
          single.year = element.year
          single.registrationDate = element.registrationDate
          single.engineSerialNo = element.engineSerialNo
          single.fuelType = element.fuelType
          single.chassisNo = element.chassisNo
          single.companyMakeCode = element.companyMakeCode
          single.vehicleRemarks = element.remark
          single.inspectionPrevDate = element.inspectionPrevDate
          single.inspectionNextDate = element.inspectionNextDate
          single.registrationLastDate = element.registrationLastDate
          single.totalWeight = element.totalWeight
          single.curbWeight = element.curbWeight
          single.transmission = element.transmission
          single.numberOfAxles = element.numberOfAxles
          single.axleWeightLimit_Front = element.axleWeightLimit_Front
          single.axleWeightLimit_Rear = element.axleWeightLimit_Rear
          single.noOfCylinders = element.noOfCylinders
          single.cylinderCapacityCM = element.cylinderCapacityCM
          single.powerKW = element.powerKW
          single.powerHP = element.powerHP
          single.noOfDoors = element.noOfDoors
          single.noOfSeats = element.noOfSeats
          single.ownerTypeId = element.ownerTypeId
          single.contactUniqueId = element.contactUniqueId
          single.isImported = !this.empty(element.isImported) ? element.isImported : false;
          single.mileage = element.mileage
          supperArray.push(single);
        })
      }
    } else if (vehicle && vehicle.length > 0) {
      vehicle.forEach(element => {
        let single = Object();
        single.id = element.vehicleId
        single.licensePlateNo = element.licensePlateNo
        single.companyModel = element.companyModel
        single.color = element.color
        single.year = element.year
        single.registrationDate = element.registrationDate
        single.engineSerialNo = element.engineSerialNo
        single.fuelType = element.fuelType
        single.chassisNo = element.chassisNo
        single.companyMakeCode = element.companyMakeCode
        single.vehicleRemarks = element.remark
        single.inspectionPrevDate = element.inspectionPrevDate
        single.inspectionNextDate = element.inspectionNextDate
        single.registrationLastDate = element.registrationLastDate
        single.totalWeight = element.totalWeight
        single.curbWeight = element.curbWeight
        single.transmission = element.transmission
        single.numberOfAxles = element.numberOfAxles
        single.axleWeightLimit_Front = element.axleWeightLimit_Front
        single.axleWeightLimit_Rear = element.axleWeightLimit_Rear
        single.noOfCylinders = element.noOfCylinders
        single.cylinderCapacityCM = element.cylinderCapacityCM
        single.powerKW = element.powerKW
        single.powerHP = element.powerHP
        single.noOfDoors = element.noOfDoors
        single.noOfSeats = element.noOfSeats
        single.contactUniqueId = element.contactUniqueId
        single.isImported = !this.empty(element.isImported) ? element.isImported : false;        
        single.mileage = element.mileage;
        supperArray.push(single);
      })
    }
    return supperArray;
  }

  private mapCustomerDetails(customer: any) {
    const supperArray = [];

    if (customer && customer.length > 0) {
      customer.forEach(element => {
        const single = {
          customerId: element.customerId,
          customerName: element.customerName,
          address: this.formatValue(element.addressLine1) + this.formatValue(element.addressLine2) + this.formatValue(element.city) + this.formatValue(element.state) + element.pincode,
          mobileNo: element.mobileNo,
          mobileCode: element.mobileCode,
          noOfVehicle: element.noOfVehicle,
          ownerType: element.ownerType,
          ownerTypeId: element.ownerTypeId,
          customerNo: element.customerNo,
          isCompany: element.isCompany,
          Id: element.contactId,
          isActive: element.isActive ?? false,
          searchSource: element.searchSource ?? 'Local',
          email: element.email,
          remark: element.remark
        };
        supperArray.push(single);
      });
    }

    return supperArray;
  }

  private mapCustomerDetail(customer: any) {
    let supperArray = [];
    if (customer && customer.length > 0) {
      customer.forEach(element => {
        const single = {
          customerId: element.customerId,
          customerName: element.custName,
          address: this.getAddress(element),
          mobileNo: element.mobileNo,
          mobileCode: element.mobileCode,
          noOfVehicle: element.noOfVehicle,
          customerNo: element.customerNo,
          isCompany: element.isCompany,
          Id: element.customerGuid,
          isActive: element.isActive ?? false,
          searchSource: element.sourceType ?? "Local",
          email: element.email,
          remark: element.remark
        };
        supperArray.push(single);
      });

    }
    return supperArray;
  }

  private mapCrmCustomerDetail(customer: any, isFromVehicleSearch = false) {
    let supperArray = [];
    if (customer && customer.length > 0) {
      if (isFromVehicleSearch) {
        customer.forEach(element => {
          const single = {
            customerId: element.customerId,
            contactId: element.contactId,
            firstName: element.firstName,
            lastName: element.lastName,
            fullName: element.customerName,
            addressLine1: element.addressLine1,
            city: element.city,
            postCode: element.pincode,
            email: element.email,
            phone: element.mobileNo,
            contactRemark: element.remark,
            navisionId: element.navisionId,
            cbid: element.cbid,
            gender: element.customerTypeId,
            state: element.state,
            country: element.country,
            isActive: element.isActive,
            campaignConsent: element.isMarketingConsent,
            emailConsent: element.isEmail,
            smsConsent: element.isSms,
            campaignNotificationConsent: element.campaignNotificationConsent,
            isMinBilUser: element.isMinBilUser,
            ownerTypeId: element.ownerTypeId,
          };
          supperArray.push(single);
        });
      } else {
        customer.forEach(element => {
          const single = {
            customerId: element.customerId,
            contactId: element.customerGuid,
            firstName: element.firstName,
            lastName: element.lastName,
            fullName: element.custName,
            addressLine1: element.addressLine1,
            city: element.city,
            postCode: element.zipcode,
            email: element.email,
            phone: element.mobileNo,
            gender: element.customerTypeId,
            state: element.state,
            country: element.country,
            campaignConsent: element.isMarketingConsent,
            emailConsent: element.isEmail,
            smsConsent: element.isSms,
            isMinBilUser: element.isMinBilUser,
            isActive: element.isActive,
            contactRemark: element.remark,
            navisionId: element.navisionId,
            cbid: element.cbid,
          };
          supperArray.push(single);
        });
      }
    }
    return supperArray;
  }

  getAddress(element: any) {
    const addressParts = [
      this.formatValue(element.address1),
      this.formatValue(element.address2),
      this.formatValue(element.city),
      this.formatValue(element.state),
      this.formatValue(element.country),
      element.zipcode ?? ''
    ];
    return addressParts.join('').trim();
  }

  formatValue(value) {
    return value === null || value === '' || value === undefined ? '' : value + ', ';
  }
  onVehicleChange(index: number) {
    this.SelectedVehicleId = this.vehicleList[index].vehicleId;
    this.SelectedLicencePlate = this.vehicleList[index].licensePlateNo;
    this.SelectedMakeCode = this.vehicleList[index].companyMakeCode;
    this.ownerTypeId = +(this.vehicleList[index].ownerTypeId?.split(",")[0])
    this.getAllDealerDetails(false);

  }
  onCustomerChange(customer: any) {
    if (customer?.isActive) {
      this.SelectedCustomerId = customer?.customerId;
      this.SelectedCustomerGuid = customer ? customer.Id : '';
      this.SelectedCustomer = customer;
      this.customerName = customer?.customerName;
      this.searchMobileNo = customer?.mobileNo;
      this.mobileCode = customer?.mobileCode;
      this.ownerTypeId = customer?.ownerTypeId
      //this.isDisabled = true;
      //this.getAllDealerDetails(false); by dharmendra as discussed with Maria.
      if (this._clientName === 'mg') {
        if (!(this.SelectedLicencePlate && this.SelectedCustomerGuid && this.selectedDealer)) {
          this.isDisabled = true;
        }
      } else if (!this.SelectedCustomerId || !this.SelectedVehicleId || !this.selectedDealer) {
        this.isDisabled = true;
      }

    }
    else {
      this.SelectedCustomerGuid = null;
      this.SelectedCustomer = null;
      this.SelectedCustomerId = null;
      this.customerName = null;
      this.searchMobileNo = null;
      this.mobileCode = null;
      this.ownerTypeId = 1
      this.isDisabled = true;

      let modelHeadermsg = this.translate.instant("lblInactiveCustomer");
      let modelBody = this.translate.instant("lblCustomerInactiveSelectionMsgAdd");
      const modalRef = this.modalService.open(NgInfoModalContent);
      modalRef.componentInstance.modelHeader = modelHeadermsg;
      modalRef.componentInstance.modelBody = modelBody;
      modalRef.result.then((_result) => {
        // This is intentional
      }, (reason) => {
        this.popupCloseResult = this.getDismissDeleteReason(reason);
      });
    }

  }
  async onCustomerChangeGetVehicle(customerId: any, isActive: any, customer: any = null) {
    if (isActive) {
      this.isDisplayVehicleForCustomer = true;
      this.spinner.show();
      this.isDisabled = true;
      this.getBrands();
      this.AssociateVehicle = false;
      this.showCustomerVehicle = customerId;
      this.SelectedCustomerId = +customerId;
      this.SelectedCustomerGuid = customer ? customer.Id : '';
      this.SelectedCustomer = customer;
      await this.GetAllAppointmentStatusList();
      await this.vehicleService.getVehicleByCustomerId(+customerId, customer ? customer.Id : '').then(async (response) => {
        if (this._clientName === 'mg') {
          this.crmVehicleDetails = this.mapCrmVehicleDetails(response.responseObject.result, true);
          if (!response.responseObject.result) {
            let lblCustomerDetailsAreNotFound = this.translate.instant("lblVehicleNotFound");
            this.toaster.error(lblCustomerDetailsAreNotFound);
          }
        }
        this.vehicleList = this.mapVehicleDetails(response.responseObject.result, true);
        this.customerName = this.customerDetails.find(x => x.customerId == +customerId)?.customerName;
        this.mobileNumber = this.customerDetails.find(x => x.customerId == +customerId)?.mobileNo;

        if (this.vehicleList && this.vehicleList?.length > 0) {
          this.SelectedMakeCode = this.vehicleList[0].companyMakeCode;
          this.SelectedVehicleId = this.vehicleList[0].vehicleId;
          this.SelectedLicencePlate = this.vehicleList[0].licensePlateNo;
          this.addAppointment = true;
          this.mobileCode = this.customerDetails.find(x => x.customerId == +customerId)?.mobileCode;
          this.isView = true;

          this.getAllDealerDetails(false);
        }
        else {
          this.AssociateVehicle = true;
        }
        const searchRequest = {
          birthDate: '',
          customerName: this.customerName,
          postCode: null,
          mobile: this.mobileNumber
        }
        await this.SearchedCustomerDFSearch(searchRequest, false);
      }, _error => {
        this.spinner.hide();
      }).finally(() => {
        this.spinner.hide();
      });

    }
    else {
      this.isDisplayVehicleForCustomer = false;
      this.isDisabled = true;
      this.AssociateVehicle = false;
      this.showCustomerVehicle = '';
      this.SelectedMakeCode = null;
      this.SelectedVehicleId = null;
      this.SelectedLicencePlate = null;
      this.SelectedCustomerId = null;
      this.SelectedCustomerGuid = null;
      this.SelectedCustomer = null;
      this.addAppointment = false;
      this.mobileCode = undefined;
      this.isView = false;
      this.customerName = "";

      let modelHeadermsg = this.translate.instant("lblInactiveCustomer");
      let modelBody = this.translate.instant("lblCustomerInactiveSelectionMsgAdd");
      const modalRef = this.modalService.open(NgInfoModalContent);
      modalRef.componentInstance.modelHeader = modelHeadermsg;
      modalRef.componentInstance.modelBody = modelBody;
      modalRef.result.then((_result) => {
        // This is intentional
      }, (reason) => {
        this.popupCloseResult = this.getDismissDeleteReason(reason);
      });
    }
  }

  calculateDateTime(selectedDate, Hour, Minute): Date {
    let dateArray = selectedDate.split('.');
    let date = +dateArray[0];
    let month = +dateArray[1];
    let year = +dateArray[2];
    return new Date(year, month - 1, date, +Hour, +Minute);
  }

  EmailNotifyUser() {
    this.isCustomerNotify = false;
    this.CreateAppointment();
  }
  private getDismissDeleteReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }

  CreateAppointment() {
    this.spinner.show();
    this.AppointmentDatetime = new Date();

    let viewModel = {
      customerId: this.SelectedCustomerId,
      vehicleId: this.SelectedVehicleId,
      dealerId: this.selectedDealer.dealerId,
      dealerDmsNo: this.selectedDealer.dealerDmsNo,
      languageCode: this.cookieservice.get('userSelectedLanguage'),
      customerDefaultLanguage: this.cookieservice.get('userSelectedLanguage'),
      bookingDate: new Date(),
      packageNumber: this.selectedPackage,
      rentalCar: this.rentalCarAvailabilities[this.selectedRentalCarIndex],
      availCheckInFacility: this.availCheckInFacility ?? false,
      deliverCarWithinBusinessHours: this.deliverOutsideBusinessHours,
      pickupCarWithinBusinessHours: this.pickupOutsideBusinessHours,
      isCustomerWaiting: this.timeSlotSection,
      //service: this.serviceList,
      service: this.ServicesSelected,
      selectedDate: null,
      isPickUpDropOffService: this.customerPickupDropOffServiceSelection,
      PickUpDateTime: this.PickupDatetime,
      Mileage: this.previousKilometerValue ? this.previousKilometerValue : null,
      OwnerTypeId: (this.ownerTypeId != null || this.ownerTypeId != undefined) ? this.ownerTypeId : 1,
      IntegrationWithDMS: false,
      AppointmentType: this.isOrder ? "Order" : "Quote",
      moduleId: Enums.ModuleNames.Appointment,
      GenerateWorkOrderNoPlannerSide: false,
      IFSWorkOrderNumber: "",
      WorkOrderStatusId: this.isOrder ? CommonEnums.WOStatus.Prepared : CommonEnums.WOStatus.WorkRequest,
      realtimeDmsSyncAppointment: true,
      UserConsent: this.UserConsent,
      IsTnCAccepted: this.UserPrivacyAccept,
      IsCustomerNotify: this.isCustomerNotify,
      IsNoNeedTransportation:true,
      IsNeedTransportTicket:false
    }

    if (this.secureStorage.getKeyData('feature') || this.userService.feature?.length > 0) {
      this.features = this.secureStorage.getKeyData('feature');
      if (this.features?.length > 0) {
        let feature = this.features.find(x => x.featureCode === Enums.FeatureCode.GWoNoPlannerSide)?.isActive
        viewModel.GenerateWorkOrderNoPlannerSide = feature;

        let featureDms = this.features.find(x => x.featureCode === Enums.FeatureCode.DMS)?.isActive
        viewModel.IntegrationWithDMS = featureDms;
        let featureAppointment = this.features.find(x => x.featureCode === Enums.FeatureCode.RTDSA)?.isActive
        viewModel.realtimeDmsSyncAppointment = featureAppointment;
      }
    }

    if (this._clientName === 'mg') {
      const selectedVehicle = this.crmVehicleDetails.find(x => x.licensePlateNo === this.SelectedLicencePlate);

      // fetch Imported car flag data from DF
      const dfVehicleData = this.vehicleDetails.find(x => !x.isNewVehicle && x.licensePlate === this.SelectedLicencePlate && x.searchSource === 'Data Factory');
      if (selectedVehicle && dfVehicleData) {
        selectedVehicle.isImported = dfVehicleData.imported;
      }
      const selectedCustomer = this.crmCustomerDetails.find(x => x.contactId === this.SelectedCustomerGuid);
      selectedCustomer.integrationWithDMS = this.features.find(x => x.featureCode === Enums.FeatureCode.CRM)?.isActive;
      if (!this.serachByLicensePlate) {
        selectedCustomer.ownerTypeId = selectedVehicle.ownerTypeId;
      }
      if (selectedCustomer && selectedVehicle && viewModel) {
        const requestBody = {
          vehicle: selectedVehicle,
          customer: selectedCustomer,
          appointment: viewModel
        }
        this.service.AddCrmAppointment(requestBody).then(res => {
          if (res.responseCode === Constant.SuccessResponseCode) {
            if (res.responseObject.result) {
              this.service.isRefreshListing = true;
              this.OnClose();
              //Show dms response failed message
              if (!this.empty(res.responseObject.result.errorMessage)) {
                this.toaster.error(res.responseObject.result.errorMessage);
              }
              let id = this.empty(res.responseObject.result.retValue) ? 0 : parseInt(res.responseObject.result.retValue);
              this.OpenEditAppointment(id);
            }
          }
          else {
            this.spinner.hide();
          }
        }).catch(_err => {
          this.spinner.hide();
        });
      }

    } else {
      this.service.AddAppointment(viewModel).then(res => {
        if (res.responseCode === Constant.SuccessResponseCode) {
          if (res.responseObject.result) {
            this.service.isRefreshListing = true;
            this.OnClose();
            //Show dms response failed message
            if (!this.empty(res.responseObject.result.resultMessage)) {
              this.toaster.error(res.responseObject.result.resultMessage);
            }
            var id = this.empty(res.responseObject.result.retValue) ? 0 : parseInt(res.responseObject.result.retValue);
            this.OpenEditAppointment(id);
          }
        }
        else {
          this.spinner.hide();
        }
      }).catch(_err => {
        this.spinner.hide();
      });
    }
  }
  GetAppointmentList(appointmentRequestModel: AppointmentRequestModel) {
    this.spinner.show();
    appointmentRequestModel.needAttention = Number(appointmentRequestModel.needAttention ? appointmentRequestModel.needAttention : 0);
    this.service.GetAppointmentList(appointmentRequestModel).then((response) => {
      if (response.responseCode == Constant.SuccessResponseCode) {
        this.appointmentList = this.AppointmentDataMapper(response.responseObject.appointmentList);
        if (this.appointmentList && this.appointmentList.length > 0) {
          this.currentLanguageService.appointmentList.next(this.appointmentList);
          this.currentLanguageService.appointmentListCount.next(response.responseObject.totalCount[0].totalCount)
        }
        this.router.navigate(['/appointment']);
        this.spinner.hide();
      }
      else if (response.responseObject && response.responseObject.errorCount > 0) {
        if (response.responseObject.result &&
          response.responseObject.result.errorCode === Enums.ErrorCodes.ServiceCategoriesCode) {
          this.spinner.hide();
        }
      }
    });
  }
  private AppointmentDataMapper(List: any) {
    let supperArray = [];
    if (List && List.length > 0) {

      for (let index = 0; index < List.length; index++) {
        const element = List[index];

        let single = Object();
        single.rowNumber = index + 1
        single.id = element.id;
        single.licensePlate = element.licensePlate;
        single.customerName = element.customerName;
        single.mobileNo = element.mobileNo;
        single.dealerName = element.dealerName;
        single.appointmentStatusColor = element.appointmentStatusColor;
        single.brand = element.brandCode;
        single.dealerId = element.dealerId;
        single.modelName = element.modelName;
        single.brandCode = element.brandCode;
        single.workOrderNo = element.workOrderNo;
        single.workOrderStatus = element.workOrderStatus;
        single.workOrderStatusId = element.workOrderStatusId;
        single.workOrderStatusColor = element.workOrderStatusColor;
        single.appointmentStatusId = element.appointmentStatusId;
        single.bookedDate = element.bookedDate;
        single.createdDate = element.createdDate ? element.createdDate : '';
        single.appointmentType = element.appointmentType;
        single.createdTime = element.createdTime;
        single.createdDateTime = element.createdDateTime;
        single.bookedDateTime = element.bookedDateTime;
        single.appointmentType = element.appointmentType;
        single.appointmentGuid = element.appointmentGuid;
        single.appointmentStatus = element.appointmentStatus;
        single.isBookingAllowed = element.isBookingAllowed;
        single.sourceCreation = element.sourceCreation;

        supperArray.push(single);
      }
    }
    return supperArray;
  }
  getBrandImage(key: any) {
    if (this.brandList) {
      if (this.brandList.filter(x => x.brandCode.toUpperCase() === key.toUpperCase()).length === 0) {
        return null;
      }
      return this.brandList.filter(x => x.brandCode.toUpperCase() === key.toUpperCase())[0].image
    }
  }
  getBrands() {
    if (!this.brandList?.length) {
      this.brandService.getBrand().then(res => {
        if (res) {
          this.brandList = res;
        }
      });
    }
  }
  onChangeService(serviceId: any): void {
    this.ServiceId = serviceId;


    this.selectedDealer = null;
    if (serviceId?.length == 0 || serviceId == undefined) {
      this.getAllDealerDetails(false);
    }
    else {
      this.serviceId = serviceId[0]?.value;
    }

    this.addAppointment = true;
    if (this.dealerDeatilList && this.dealerDeatilList.length == 1) {
      this.loginDealerIndex = -1;
    }


    this.isNeedRentalCar = false;
    this.rentalCarAvailabilities = [];
    this.dealerDeatilList = [];

    if (this.customerPickupDropOffServiceSelection) {
      for (let value of this.dealerDeatils) {
        if (value.service != null) {
          let flag = true;
          for (let scount = 0; scount < serviceId?.length; scount++) {
            if (
              value.service.findIndex((x) => x.serviceId === serviceId[scount].value) === -1
            ) {
              flag = false;
              break;
            }
          }
          if (flag && value.isVehiclePickUpAndDropOffService) {
            this.dealerDeatilList.push(value);
          }
        }
      }
    }
    else {
      for (let value of this.dealerDeatils) {
        if (value.service != null) {
          let flag = true;
          for (let scount = 0; scount < serviceId?.length; scount++) {
            if (
              value.service.findIndex((x) => x.serviceId === serviceId[scount].value) === -1
            ) {
              flag = false;
              break;
            }
          }
          if (flag) {
            this.dealerDeatilList.push(value);
          }
        }
      }
    }

    if (this.selectedDealer) {
      this.selectedService = this.dealerDeatilList.filter(x => x.service.filter(y => y.serviceId === +this.serviceId))[0];
      if (this.dealerDeatilList && this.dealerDeatilList.length == 1) {
        this.onChangeDealer(this.loginDealerIndex);
      }
      if (this.dealerDeatilList.length === 0) {
        this.loginDealerIndex = -1;
      }
      this.goToAdditionalServiceSection();
    }


  }

  onChangePackage(val: any) {
    this.selectedPackage = val !== undefined ? val : '';
  }

  onChangeDealer(index: any) {
    if (this.dealerDeatilList.length > 0)
      this.isNeedRentalCar = false;
    this.onChangeRentalCar();
    this.loginDealerIndex = index;
    this.selectedDealer = this.dealerDeatilList.find(x => x.dealerId === index);
    this.dealerNextAvailDate = Utility.GetFormattedDate(this.selectedDealer.nextAvailableDate);
    this.selectedDate = this.dealerNextAvailDate;
    this.selectedDateTime = this.selectedDealer.nextAvailableDate;
    this.isDealerBrandValid();
    if (this._clientName === 'mg') {
      if (!(this.SelectedLicencePlate && this.SelectedCustomerGuid && this.selectedDealer)) {
        this.isDisabled = true;
      }
    } else if (!(this.SelectedVehicleId && this.SelectedCustomerId && this.selectedDealer)) {
      this.isDisabled = true;
    }
  }

  disableDealerNotAvailableDates(): void {
    if (this.selectedDealer) {
      this.disableDealerNotOpenDates();
      this.disableDealerHolidayDates();
    }
  }

  disableDealerNotOpenDates(): void {
    this.enablePreviousClosedDates();
    const calendar = this.appointmentBookingCalendar?.nativeElement?.querySelectorAll('.xdsoft_date:not(.xdsoft_disabled)');
    if (calendar && this.selectedDealer) {
      const dealerNotOpenDaysList = this.getNotOpenDaysOfDealer();
      // tslint:disable-next-line: no-shadowed-variable
      if (dealerNotOpenDaysList.length > 0) {
        for (const element of calendar) {
          const mainDate = this.getDateStringFromCalenderElement(element);
          const day = Utility.getDateStringToDate(mainDate).getDay();
          const index = dealerNotOpenDaysList.findIndex(x => x === day);
          if (index === -1) {
            element.classList.remove('xdsoft_disabled');
          } else {
            element.classList.add('xdsoft_disabled');
            element.classList.add('closed');
          }
        }
      }
    }
  }

  disableDealerHolidayDates(): void {
    this.enablePreviousHolidayDates();
    const disableDatesOfCalender = [];
    this.selectedDealer.holidaysList.forEach(x => {
      x.holidayDates.forEach(y => {
        const date = Utility.GetFormattedDate(y);
        disableDatesOfCalender.push(date);
      });
    });
    this.setClassOfCalender('holiday', disableDatesOfCalender);
    this.setClassOfCalender('xdsoft_disabled', disableDatesOfCalender);
  }

  enablePreviousHolidayDates() {
    const holidayDates = this.appointmentBookingCalendar?.nativeElement?.querySelectorAll('.xdsoft_date.holiday');
    if (holidayDates) {
      for (const element of holidayDates) {
        element.classList.remove('xdsoft_disabled');
        element.classList.remove('holiday');
      }
    }
  }

  enablePreviousClosedDates() {
    const closedDates = this.appointmentBookingCalendar?.nativeElement?.querySelectorAll('.xdsoft_date.closed');
    if (closedDates) {
      for (const element of closedDates) {
        element.classList.remove('xdsoft_disabled');
        element.classList.remove('closed');
      }
    }
  }

  getNotOpenDaysOfDealer(): number[] {

    const dealerNotOpenDaysList: number[] = [];
    const dealerOpenDaysList: number[] = [];
    let dealerNotOpenDays2DList = this.selectedDealer.openingHoursList.filter(x => x.isOpen).map(x => x.dayNumbers);
    dealerNotOpenDays2DList.forEach(days => {
      dealerOpenDaysList.push(...days);
    });
    for (let i = 0; i <= 6; i++) {
      if (dealerOpenDaysList.indexOf(i) === -1) {
        dealerNotOpenDaysList.push(i);
      }
    }
    return dealerNotOpenDaysList;
  }

  getDateStringFromCalenderElement(calElement: any): string {
    let dataDate = calElement.getAttribute('data-date');
    const dataMonth = calElement.getAttribute('data-month');
    const dataYear = calElement.getAttribute('data-year');

    if (dataDate.length === 1) {
      dataDate = '0' + dataDate;
    }
    let finalMonthValue = String(+dataMonth + 1);
    if (finalMonthValue.length === 1) {
      finalMonthValue = '0' + finalMonthValue;
    }
    return dataDate + '.' + finalMonthValue + '.' + dataYear;
  }

  setClassOfCalender(className: string, data: any[], flag: boolean = true): void {
    const calendar = this.appointmentBookingCalendar?.nativeElement?.querySelectorAll('.xdsoft_date:not(.xdsoft_disabled)');
    if (calendar) {
      // tslint:disable-next-line: no-shadowed-variable
      for (const element of calendar) {
        const mainDate = this.getDateStringFromCalenderElement(element);
        for (const availableDate of data) {
          if (mainDate === availableDate) {
            if (flag) {
              element.classList.add(className);
            } else {
              element.classList.remove(className);
            }
          }
        }
      }
    }
  }

  changeDate(event) {
    this.selectedDate = Utility.GetFormattedDate(event);
    this.selectedDateTime = event;
    this.getBusinessHour(this.selectedDateTime);
  }

  onChangeMonthYear(_event: any) {
    // This is intentional
  }

  onChangeInCalender() {
    this.disableDealerNotAvailableDates();
    if (this.isRentalCarSelected()) {
      this.makeAvailableDateGeenInCalender();
    } else {
      this.rentalCarValidationMessage = false;
      this.removeClassFromCalender('date-green-bg');
    }
    this.rentalCarValidationCheck();
  }
  OpenAppointmentPopUp(content) {
    this.spinner.show();
    this.service.getActiveAppointment(this.SelectedVehicleId, this.SelectedCustomerId, this.cookieservice.get('userSelectedLanguage')).then((res) => {
      if (res && res.length > 0) {
        this.activeAppointmentList = this.mapActiveAppointment(res);
        if (this.activeAppointmentList && this.activeAppointmentList?.length > 0) {
          this.spinner.hide();
          const modalRef = this.modalService.open(content, { size: 'lg', windowClass: 'pop-wid1200 pop-hig80vh pop-mh80' });
          modalRef.result.then((_result) => {
            // This is intentional
          }, (_reason) => {
            // This is intentional
          })
        }
        else {
          this.spinner.hide();
          this.ConfirmAddAppointment();
        }
      }
      else {
        this.spinner.hide();
        this.ConfirmAddAppointment();
      }
    }).catch(_err => {
      this.spinner.hide();
    })
  }
  CloseAttention() {
    if (this.serachByLicensePlate) { this.mobileNumber = null }
    this.modalService.dismissAll();
  }
  private mapActiveAppointment(List: any) {
    let supperArray = [];
    if (List && List.length > 0) {
      for (let index = 0; index < List.length; index++) {
        const element = List[index];
        let single = Object();
        single.rowNumber = index + 1;
        single.id = element.id;
        single.licensePlate = element.licensePlate;
        single.customerName = element.customerName;
        single.mobileNo = element.mobileNo;
        single.mobileCode = element.mobileCode;
        single.dealerName = element.dealerName;
        single.appointmentStatusColor = element.appointmentStatusColor;
        single.brand = element.brandCode;
        single.dealerId = element.dealerId;
        single.modelName = element.modelName;
        single.brandCode = element.brandCode;
        single.brandName = element.brandName;
        single.workOrderNo = element.workOrderNo;
        single.workOrderStatus = element.workOrderStatus;
        single.workOrderStatusId = element.workOrderStatusId;
        single.workOrderStatusColor = element.workOrderStatusColor;
        single.appointmentStatusId = element.appointmentStatusId;
        single.bookedDate = element.bookedDate;
        single.createdDate = element.createdDate;
        single.createdDateTime = element.createdDateTime ? new Date(element.createdDateTime + 'Z') : null;
        single.bookedDateTime = element.bookedDateTime;
        single.appointmentType = element.appointmentType;
        single.appointmentGuid = element.appointmentGuid;
        single.createdTime = element.createdTime;
        single.appointmentStatus = element.appointmentStatus;
        single.isBookingAllowed = element.isBookingAllowed;
        single.sourceCreation = element.sourceCreation;
        single.unitPrice = element.unitPrice;
        single.chassisNo = element.chassisNo;
        supperArray.push(single);
      }
    }
    return supperArray;
  }
  editAppointment(appointment) {
    this.multiStackPopupService.OpenAppointment(appointment.id);
  }


  async GetAllAppointmentStatusList() {
    if (!this.appointmentStatusList?.length) {
      let language = this.cookieservice.get('userSelectedLanguage')
      await this.service.GetAppointmentStatusList(language).then(data => {
        if (data?.woStatusList) {
          this.appointmentStatusList = data.woStatusList;
          this.service.appointmentStatusList = this.appointmentStatusList;
        }
      });
    }
  }

  ConfirmAddAppointment() {
    this.EmailNotifyUser();
  }
  OpenEditAppointment(id) {
    this.multiStackPopupService.OpenAppointment(id);
  }

  isDealerBrandValid() {
    const errorMsg = this.translate.instant("lblNoDealerAvailabilityForThisVehicleBrand");

    if (!this.dealerBrandDeatils?.length) {
      this.isDisabled = true;
      this.toaster.error(errorMsg);
      return;
    }

    if (this.selectedDealer?.dealerId !== null && this.selectedDealer?.dealerId !== undefined) {
      const exist = this.dealerBrandDeatils.find(x => x.dealerId === this.selectedDealer.dealerId);
      if (!exist) {
        this.isDisabled = true;
        this.toaster.error(errorMsg);
        return;
      }
    }

    if (this._clientName !== 'mg') {
      if (
        (this.SelectedCustomerId !== null && this.SelectedCustomerId !== undefined && this.SelectedCustomerId < 1) ||
        (this.SelectedVehicleId !== null && this.SelectedVehicleId !== undefined && this.SelectedVehicleId < 0)
      ) {
        this.toaster.error(errorMsg);
        this.spinner.hide();
        return;
      }
    }

    if (this.selectedDealer?.dealerId === null || this.selectedDealer?.dealerId === undefined) {
      if (!this.toasterShown) {
        const selectDealerMsg = this.translate.instant("lblSelectDealerToProccedFurther");
        this.toaster.error(selectDealerMsg); // Replace with the actual code to show the toaster message
        this.toasterShown = true;

        // Optionally, reset the flag after a certain timeout if you want to allow the toaster to be shown again
        setTimeout(() => {
          this.toasterShown = false;
        }, 3000); // Example: reset after 5 seconds
      }
    }
    this.isDisabled = false;
  }
  //#region Data Factory
  OnThirdPartyCustomerSearch() {
    if (this.isThirdPartyActive) {
      let modelBodymsg = this.translate.instant('lblSureToSearchDF');
      let modelHeadermsg = this.translate.instant('lblDFSearch');
      const modalRef = this.modalService.open(NgbdModalContent);
      modalRef.componentInstance.modelHeader = modelHeadermsg;
      modalRef.componentInstance.modelBody = modelBodymsg;
      modalRef.result.then(
        () => {
          // This is intentional
        },
        reason => {
          if (reason) {
            if (this.isThirdPartyActive) {
              this.DFCustomerSearch();
            }
          }
        }
      );
    }
  }
  DFCustomerSearch() {
    this.spinner.show();
    const searchRequest = {
      birthDate: '',
      customerName: this.MobileAdvanceSearch ? this.MobileAdvanceSearchRequestModel.firstName : this.customerName,
      postCode: null,
      mobile: this.MobileAdvanceSearch ? this.MobileAdvanceSearchRequestModel.mobileNo : this.mobileNumber
    }
    this.customerService.getDFCustomerListByAdvanceSearch(searchRequest).then((response) => {
      if (response?.responseObject?.length > 0) {
        const CustomerList = this.customerService.DFCustomerDataMapper(response.responseObject);
        if (CustomerList?.length == 1) {
          this.OnAddCustomer(0, CustomerList[0]);
        } else {
          this.OpenMultipleCustomerList(CustomerList, CustomerList.length);
        }
      }
      else {
        let lblCustomerDetailsAreNotFound = this.translate.instant("lblCustomerDetailsAreNotFound.");
        this.toaster.error(lblCustomerDetailsAreNotFound);
      }
    }).finally(() => {
      this.spinner.hide();
    });
  }
  OnAddVehicle(vehicle: any) {
    this.spinner.show();

    if (this._clientName === 'mg') {
      this.vehicleService.crmCustomerObj = this.dfCustomerForCRM;
      this.vehicleService.vinNo= vehicle.chassisNo;
      this.vehicleService.customerName= this.dfCustomerForCRM.fullName;
      this.vehicleService.customerId= 0;
      this.vehicleService.customerNo= null;
    }

    const modalref = this.modalService.open(AddVehicleComponent, { size: 'lg', windowClass: 'EditPopup appWid' });
    modalref.componentInstance.isAddFromAppointment = this._clientName !== 'mg';
    modalref.componentInstance.vehicleDetail = vehicle;

    modalref.result.then((_response) => {
      this.SearchLicensePLate();
    });
  }
  OpenMultipleCustomerList(customerList: CustomerDetailsViewModel[], totalCount: number): void {
    const modalref = this.modalService.open(MultiCustomerListComponent, {
      size: 'lg',
      scrollable: true,
      windowClass: 'pop-wid1366 CustomCardPopup',
    });

    modalref.componentInstance.customerList = customerList;
    modalref.componentInstance.totalCount = totalCount;
    modalref.result.then(
      (response) => {
        if (response.success) {
          this.OnAddCustomer(0, response.customer);
        }
      },
      () => {
        // This is intentional
      }
    );
  }
  OnAddCustomer(customerId: number = 0, detail: any = undefined) {
    this.spinner.show();
    this.customerService.customerId = customerId;
    this.customerService.customerFromCaller = detail;
    if (this._clientName === 'mg') {
      const selectedVehicle = this.crmVehicleDetails.find(x => x.licensePlateNo === this.SelectedLicencePlate);
      this.customerService.crmVehicleObj = selectedVehicle;
    }
    const modalref = this.modalService.open(ViewCustomerComponent, { size: 'lg', windowClass: 'EditPopup appWid' });
    modalref.componentInstance.hideCustomer = false;
    modalref.componentInstance.isView = true;
    if (this.IsCustomerAddFromVehicle && this.VehicleNumberOnAddCustomer) {
      this.customerService.IsCustomerAddFromVehicle = true;
      this.customerService.VehicleNumber = this.VehicleNumberOnAddCustomer;
    }
    modalref.result.then((response) => {
      if (response.success && !this.IsCustomerAddFromVehicle) {
        this.ApplyMobileAdvanceSearch();
      }
    });
  }
  empty(e: any) {
    switch (e) {
      case "":
      case null:
      case undefined:
        return true;
      default:
        return false;
    }
  }
  async SearchedCustomerDFSearch(searchRequest, showCustomer) {
    this.spinner.show();
    searchRequest.customerName = "";
    await this.customerService.getDFCustomerListByAdvanceSearch(searchRequest).then((response) => {
      if (response?.responseObject?.length > 0) {
        if (showCustomer) {
          const CustomerList = this.customerService.DFCustomerDataMapper(response.responseObject);
          this.bindDataFactoryCustomer(CustomerList);
        } else {
          let resultList = response.responseObject;
          if (resultList != null) {
            resultList.forEach(v => {
              let vList = v.vehicles;
              if (vList != null) {
                vList.forEach(result => {
                  this.bindDataFactoryVehicle(result, true);
                });
              } else {
                let lblCustomerDetailsAreNotFound = this.translate.instant("lblVehicleDataFactoryNotFound");
                this.toaster.error(lblCustomerDetailsAreNotFound);
              }
            });
          } else {
            let lblCustomerDetailsAreNotFound = this.translate.instant("lblVehicleDataFactoryNotFound");
            this.toaster.error(lblCustomerDetailsAreNotFound);
          }
        }
      }
      else if (showCustomer) {
        let lblCustomerDetailsAreNotFound = this.translate.instant("lblCustomerDataFactoryNotFound");
        this.toaster.error(lblCustomerDetailsAreNotFound);
      } else {
        let lblCustomerDetailsAreNotFound = this.translate.instant("lblVehicleDataFactoryNotFound");
        this.toaster.error(lblCustomerDetailsAreNotFound);
      }
    }).finally(() => {
      this.spinner.hide();
    });
  }


  async SearchedVehicleDFSearch(licensePlateNo, isFromCustomerSelection, showCustomer) {
    this.spinner.show();
    await this.vehicleService.getVehicleFrmoDataFactoryByLicencePlateNo(licensePlateNo).then(async (response) => {
      if (response.responseCode === Constant.SuccessResponseCode) {
        if (response.responseObject != null && response.responseObject.length != 0) {

          if (response.responseObject[0].vehicles == null || response.responseObject[0].vehicles.length == 0) {
            let errorMsg = this.translate.instant('lblVehicleDataFactoryNotFound');
            this.toaster.error(errorMsg);
            this.spinner.hide();
          }
          else {
            let result = response.responseObject[0].vehicles[0];
            //this.OnAddVehicle(result);
            this.bindDataFactoryVehicle(result, isFromCustomerSelection);

            if (showCustomer) {
              const CustomerList = await this.customerService.DFCustomerDataMapper(response.responseObject);
              this.bindDataFactoryCustomer(CustomerList);
              if(this.customerList != null && CustomerList.length > 0){
                const model  = {
                  MobileNo: CustomerList[0].mobileNo,
                  Email: CustomerList[0].email,
                  FullName: CustomerList[0].customerName
                };
                this.existingDFCustomerDetails = [];
                await this.vehicleService.SearchCustomerThroughDF(model).then((response) =>{
                  if(response.responseObject.length > 0){
                    this.bindExistingDFCustomer(response.responseObject);
                  }
                })
              }
            }
            this.spinner.hide();
          }
        }
        else {
          let errorMsg = this.translate.instant('lblVehicleDataFactoryNotFound');
          this.toaster.error(errorMsg);
          this.spinner.hide();
        }
      }
    },
      _error => {
        this.spinner.hide();
      });
  }

  bindDataFactoryCustomer(CustomerList) {
    if (CustomerList?.length > 0) {
      CustomerList.forEach(element => {
        element.pincode = element.pincode ?? ''
        let single = Object();
        single.customerId = 0;
        single.customerName = !this.empty(element.customerName) ? element.customerName : "";
        single.address = this.formatValue(element.addressLine1) + this.formatValue(element.addressLine2) + this.formatValue(element.city) + this.formatValue(element.state) + element.pincode
        single.mobileNo = !this.empty(element.mobileNo) ? element.mobileNo : "";
        single.mobileCode = !this.empty(element.mobileCode) ? element.mobileCode : "";
        single.noOfVehicle = 0;
        single.ownerType = "Owner";
        single.ownerTypeId = "";
        single.customerNo = "";
        single.isCompany = element.customerTypeId == 2 ? true : false;
        single.isActive = false;
        single.searchSource = 'Data Factory'
        this.customerDetails.push(single);
      });
    }
  }

  bindExistingDFCustomer(CustomerList) {
    if (CustomerList?.length > 0) {
      CustomerList.forEach(element => {
        element.pincode = element.pincode ?? ''
        let single = Object();
        let searchArray = element.searchThrough.split(',');
        let searchString = '';
        if(searchArray.length>0){
          searchArray.forEach(element => {
            searchString = searchString != '' ? searchString + ' ,' + this.translate.instant(element) : this.translate.instant(element);
          });
        }
        else{
          searchString = this.translate.instant(searchArray);
        }
        single.customerId = 0;
        single.customerName = !this.empty(element.customerName) ? element.customerName : "";
        single.address = this.formatValue(element.addressLine1) + this.formatValue(element.addressLine2) + this.formatValue(element.city) + this.formatValue(element.state) + element.pincode
        single.mobileNo = !this.empty(element.mobileNo) ? element.mobileNo : "";
        single.mobileCode = !this.empty(element.mobileCode) ? element.mobileCode : "";
        single.noOfVehicle = 0;
        single.ownerType = "";
        single.ownerTypeId = "";
        single.customerNo = element.customerNo ? element.customerNo : "";
        single.isCompany = element.customerTypeId == 2 ? true : false;
        single.isActive = element.isActive;
        single.searchSource = 'Local';
        single.searchThrough = searchString;
        single.isCompany = element.isCompany;
        this.existingDFCustomerDetails.push(single);
      });
    }
  }

  convertdateformat(date) {
    return date.split('-')[2] + '.' + date.split('-')[1] + '.' + date.split('-')[0]
  }

  bindDataFactoryVehicle(result, isFromCustomerSelection) {
    if (isFromCustomerSelection) {
      let single = Object();
      single.vehicleId = 0
      single.licensePlateNo = result.plateNumber
      single.companyMakeCode = !this.empty(result.brandName) ? result.brandName : "";
      single.model = !this.empty(result.modelName) ? result.modelName : "";
      if (result.color) {
        single.color = !this.empty(result.color.text) ? result.color.text : "";
      } else {
        single.color = !this.empty(result.colorText) ? result.colorText : "";
      }
      single.year = !this.empty(result.modelYear) ? result.modelYear : 0;
      if (result.date) {
        single.registrationDate = !this.empty(result.date.registration) ? result.date.registration.first : "";
        single.inspectionNextDate = !this.empty(result.date.inspection) ? result.date.inspection.next : "";
      } else {
        single.registrationDate = !this.empty(result.firstRegistrationDate) ? result.firstRegistrationDate : "";
        single.inspectionNextDate = !this.empty(result.nextInspectionDate) ? result.nextInspectionDate : "";
      }
      if (!this.empty(single.registrationDate)) {
        single.registrationDate = this.convertdateformat(single.registrationDate);
      }
      if (!this.empty(single.inspectionNextDate)) {
        single.inspectionNextDate = this.convertdateformat(single.inspectionNextDate);
      }

      if (result.fuelType) {
        single.fuel = !this.empty(result.fuelType.text) ? result.fuelType.text : "";
      } else {
        single.fuel = !this.empty(result.fuelTypeText) ? result.fuelTypeText : "";
      }
      single.brand = !this.empty(result.brandName) ? result.brandName : "";
      single.vehicleGroup = "";
      single.chassisNo = !this.empty(result.vehicleIdentificationNumber) ? result.vehicleIdentificationNumber : "";
      single.id = 0;
      single.ownerName = !this.empty(result.ownerName) ? result.ownerName : "";
      single.ownerType = !this.empty(result.ownerType) ? result.ownerType : "";
      single.searchSource = 'Data Factory'
      single.isNewVehicle = false;
      let findIndex = this.vehicleList.findIndex(x => x.chassisNo === result.vehicleIdentificationNumber);
      if (findIndex < 0) {
        single.isNewVehicle = true;
      }
      single.imported = !this.empty(result.imported) ? result.imported : false;
      this.vehicleList.push(single);
    } else {
      let single = Object();
      single.vehicleId = 0
      single.licensePlate = result.plateNumber
      single.makeCode = !this.empty(result.brandName) ? result.brandName : "";
      single.model = !this.empty(result.modelName) ? result.modelName : "";
      if (result.color) {
        single.color = !this.empty(result.color.text) ? result.color.text : "";
      } else {
        single.color = !this.empty(result.colorText) ? result.colorText : "";
      }
      single.year = !this.empty(result.modelYear) ? result.modelYear : 0;
      if (result.date) {
        single.registrationDate = !this.empty(result.date.registration) ? result.date.registration.first : "";
        single.inspectionNextDate = !this.empty(result.date.inspection) ? result.date.inspection.next : "";
      } else {
        single.registrationDate = !this.empty(result.firstRegistrationDate) ? result.firstRegistrationDate : "";
        single.inspectionNextDate = !this.empty(result.nextInspectionDate) ? result.nextInspectionDate : "";
      }

      if (result.fuelType) {
        single.fuel = !this.empty(result.fuelType.text) ? result.fuelType.text : "";
      } else {
        single.fuel = !this.empty(result.fuelTypeText) ? result.fuelTypeText : "";
      }
      single.brand = !this.empty(result.brandName) ? result.brandName : "";
      single.vehicleGroup = "";
      single.chassisNo = !this.empty(result.vehicleIdentificationNumber) ? result.vehicleIdentificationNumber : "";
      single.id = 0;
      single.ownerName = !this.empty(result.ownerName) ? result.ownerName : "";
      single.ownerType = !this.empty(result.ownerType) ? result.ownerType : "";
      single.searchSource = 'Data Factory'
      single.isNewVehicle = false;
      let findIndex = this.vehicleDetails.findIndex(x => x.chassisNo === result.vehicleIdentificationNumber);
      if (findIndex < 0) {
        single.isNewVehicle = true;
      }
      single.isImported = !this.empty(result.imported) ? result.imported : false;
      this.vehicleDetails.push(single);
    }
  }

  viewVehicle(vehicle, isFromCustomerSelection) {
    this.vehicleService.vehicleId = parseInt(vehicle.vehicleId);
    this.vehicleService.licensePlate = isFromCustomerSelection ? vehicle.licensePlateNo : vehicle.licensePlate;
    this.vehicleService.make = isFromCustomerSelection ? vehicle.companyMakeCode : vehicle.makeCode;
    this.vehicleService.model = vehicle.model;
    this.vehicleService.vinNo = vehicle.chassisNo;
    this.vehicleService.vehicleGuid = '';
    const modalref = this.modalService.open(EditVehicleComponent, {
      size: 'lg',
      windowClass: 'EditPopup',
    });
    modalref.componentInstance.fromHistory = false;
    modalref.componentInstance.fromWorkOrder = false;
    modalref.result.then(
      (response) => {
        if (isFromCustomerSelection) {
          this.onCustomerChangeGetVehicle(this.SelectedCustomerId, true, this.SelectedCustomer);
        } else {
          this.SearchLicensePLate();
        }
      },
    );
  }

  async viewCustomer(customer, searchfromVehicle) {
    this.customerService.customerId = customer.customerId;
    this.customerService.customerNo = customer.customerNo;
    this.customerService.customerName = customer.customerName;
    this.customerService.firstName = "";
    this.customerService.lastName = "";
    const modalref = this.modalService.open(ViewCustomerComponent, { size: 'lg', windowClass: 'EditPopup' });
    modalref.componentInstance.isFromServiceAdvisor = false;
    modalref.componentInstance.fromVehicleScreen = false;
    modalref.componentInstance.fromVehicleCustomerDetails = false;
    modalref.result.then(
      async (response) => {
        if (searchfromVehicle) {
          this.SearchLicensePLate();
        } else {
          this.spinner.show();
          await this.fcService.getCustomerListUsingMobile(this.mobileNumber, this.MobileAdvanceSearchRequestModel.mobileNo, this.MobileAdvanceSearchRequestModel.customerNo, this.MobileAdvanceSearchRequestModel.firstName)
            .then(async (result) => {
              const responseObject = result.responseObject.result;
              if (responseObject && responseObject?.length > 0) {
                this.customerDetails = this.mapCustomerDetail(responseObject);
                const searchRequest = {
                  birthDate: '',
                  customerName: this.MobileAdvanceSearch ? this.MobileAdvanceSearchRequestModel.firstName : this.customerName,
                  postCode: null,
                  mobile: this.MobileAdvanceSearch ? this.MobileAdvanceSearchRequestModel.mobileNo : this.mobileNumber
                }
                await this.SearchedCustomerDFSearch(searchRequest, true)

              } else {
                if (this._clientName === 'mg') {
                  let lblCustomerDetailsAreNotFound = this.translate.instant("lblCustomerDetailsAreNotFound.");
                  this.toaster.error(lblCustomerDetailsAreNotFound);
                }
                this.spinner.hide();
              }
            });
        }
      },
    );
  }

  async AddNewVehicle(vehicle) {
    if (this.empty(this.SelectedCustomerId)) {
      return;
    }

    if (this._clientName === 'mg') {
      const selectedCustomer = this.crmCustomerDetails.find(x => x.contactId === this.SelectedCustomerGuid);
      this.vehicleService.crmCustomerObj = selectedCustomer;
    }
    let customerObj = this.customerDetails.filter(x => x.customerId == this.SelectedCustomerId)[0];
    this.vehicleService.vinNo = vehicle.chassisNo;
    this.vehicleService.customerId = customerObj.customerId;
    this.vehicleService.customerNo = customerObj.customerNo;
    this.vehicleService.customerName = customerObj.customerName;
    const modalref = this.modalService.open(AddVehicleComponent, { size: 'lg', windowClass: 'EditPopup appWid' });
    modalref.componentInstance.isAddFromAppointment = false;
    modalref.componentInstance.vehicleDetail = vehicle;

    modalref.result.then((_response) => {
      if (_response.success) {
        this.onCustomerChangeGetVehicle(this.SelectedCustomerId, true, this.vehicleService.crmCustomerObj);
      }
    });

  }
  //#endregion
}
//test call